export const ACTIVE_MCA_STATUSES = ["PENDING", "IN_PROGRESS", "REJECTED"];

export const isMcaIntercepted = (result) => !!result?.data?.mcaIntercepted;

export const getMcaApprovingBannerTitle = (action, status) => {
  const actionLabels = {
    CREATE: "Create",
    UPDATE: "Update",
    DELETE: "Delete",
  };
  const actionLabel = actionLabels[action] ?? action ?? "Change";
  if (status === "REJECTED") {
    return `${actionLabel} rejected`;
  }
  return `Approving for ${actionLabel}`;
};

export const getMcaSubmittedNotificationTitle = () => `Submitted for approval`;

export const getMcaSubmittedNotificationMessage = (result) => {
  const action = result?.data?.mcaRequest?.action;
  const actionLabels = {
    CREATE: "create",
    UPDATE: "update",
    DELETE: "delete",
  };
  const verb = actionLabels[action] ?? "change";
  return (
    result?.data?.message ??
    `Your ${verb} request will apply after approval.`
  );
};

export const getMcaApprovalLabel = (action, status) => {
  const actionLabels = {
    CREATE: "Create",
    UPDATE: "Update",
    DELETE: "Delete",
  };
  const actionLabel = actionLabels[action] ?? action ?? "Change";
  if (status === "REJECTED") {
    return `${actionLabel} Rejected`;
  }
  return actionLabel;
};

export const getMcaApprovalTooltip = (request) => {
  if (!request) return null;
  const processName = request.process?.name;
  const subject =
    processName ?? getMcaApprovalLabel(request.action, request.status);
  if (request.status === "REJECTED") {
    return `Rejected approval for ${subject}`;
  }
  return `Pending approval for ${subject}`;
};

const resolveRequestId = (request) => {
  if (!request) return null;
  if (typeof request === "string") return request;
  return request._id ?? null;
};

export const isEntityMcaLocked = (entity) => !!getActiveMcaRequest(entity);

export const getActiveMcaRequest = (entity) => {
  const request = entity?.mcaRequestId;
  if (!request) return null;

  if (typeof request !== "object") {
    if (!entity?.mcaPending) return null;
    return {
      _id: request,
      action: "CREATE",
      status: "PENDING",
    };
  }

  if (!ACTIVE_MCA_STATUSES.includes(request.status)) return null;
  return request;
};

export const getMcaRequestId = (entity) => {
  const active = getActiveMcaRequest(entity);
  return active?._id ?? resolveRequestId(entity?.mcaRequestId);
};
